import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GEOGRAPHY_REPOSITORY,
  GeographyRepository
} from '@app/domain/repositories/geography/geography.repository.contract';
import { Country } from '@app/entities/models/geography/country.model';
import { GeographicalBoundary } from '@app/entities/models/geography/geography.model';
import { PhonePrefix } from '@app/entities/models/geography/phone-prefix.model';
import { StreetType } from '@app/entities/models/geography/street-type-model';

import { GeographyUseCases } from './geography.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class GeographyUseCasesImpl implements GeographyUseCases {
  #geographyRepository: GeographyRepository = inject(GEOGRAPHY_REPOSITORY);

  getCountries(): Observable<Country[]> {
    return this.#geographyRepository.getCountries();
  }

  getPostalCodes(countryIsoNumericCode: string, alternativeCode: string): Observable<string[]> {
    return this.#geographyRepository.getPostalCodes(countryIsoNumericCode, alternativeCode);
  }

  getStreetTypes(): Observable<StreetType[]> {
    return this.#geographyRepository.getStreetTypes();
  }

  getPhonePrefixes(): Observable<PhonePrefix[]> {
    return this.#geographyRepository.getPhonePrefixes();
  }

  getGeographicalBoundaries(
    countryIsoNumericCode: string,
    alternativeCode?: string,
    parentTypeId?: string
  ): Observable<GeographicalBoundary[]> {
    return this.#geographyRepository.getGeographicalBoundaries(countryIsoNumericCode, alternativeCode, parentTypeId);
  }
}
